<template>
    <div class="deletearea safe-distance-top">
        <div class="deletearea_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <div class="my">学科领域</div>
            <div class="determine" @click="toInformation">确定</div>
        </div>
        <div class="deletearea_bottm">
            <van-field
                center
                style="border-radius: 8px; height: 48px"
                v-model="form.fieldValue"
                is-link
                readonly
                label="科学领域"
                placeholder="请输入"
                @click="show = true"
            />
            <div class="search">
                <van-popup v-model="show" round position="bottom">
                    <van-cascader
                        v-model="cascaderValue"
                        title="科学领域"
                        :options="options"
                        @close="show = false"
                        @finish="onFinish"
                        :field-names="fieldNames"
                    />
                </van-popup>
            </div>
        </div>
        <div class="exit">
            <van-button class="bot" @click="shows = true">删除</van-button>
            <van-action-sheet
                v-model="shows"
                :actions="actions"
                cancel-text="取消"
                description="确定要删除学科领域？"
                close-on-click-action
                style="color: #ff3d3d"
                @select="onSelect"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "deletearea",
    data() {
        return {
            itemIndexs: "",
            userInfo: "",
            show: false,
            keyword: "",
            form: {
                fieldValue: "",
            },
            cascaderValue: "",
            // 选项列表，children 代表子选项，支持多级嵌套
            options: [],
            fieldNames: {
                text: "label",
                value: "value",
                children: "children",
            },
            shows: false,
            actions: [{ name: "删除" }],

            // 修改
            modify: {
                levelOne: "",
                levelOneName: "",
                levelTwo: "",
                levelTwoName: "",
            },
        };
    },
    created() {
        this.item = JSON.parse(this.$route.query.item);
        // console.log(this.item);
        if (this.item) {
            let oneName = this.item.levelOneName;
            let twoName = this.item.levelTwoName;
            this.form.fieldValue = oneName + "," + twoName;
        }
        this.itemIndexs = JSON.parse(this.$route.query.indexs);
        this.getRelationList();
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        // 全部选项选择完毕后，会触发 finish 事件
        onFinish({ selectedOptions }) {
            this.show = false;
            this.modify.levelOne = selectedOptions[0].value;
            this.modify.levelTwo = selectedOptions[1].value;
            this.modify.levelOneName = selectedOptions[0].label;
            this.modify.levelTwoName = selectedOptions[1].label;
            this.form.fieldValue = selectedOptions.map((option) => option.label).join(",");
            console.log(selectedOptions);
        },
        async getRelationList() {
            const data = await this.$apis.userServe.getRelationList();
            this.options = data.data;
        },
        // 确认删除
        onSelect() {
            this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));

            this.userInfo.sysUserSubject.splice(this.$route.query.indexs, 1);

            sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));

            this.$router.push("information");
        },
        onSearch() {
            this.filteredOptions = this.options.filter((option) => {
                return option.name.indexOf(this.keyword) !== -1;
            });
            this.columns[0].values = this.filteredOptions.map((option) => option.label);
        },
        // 修改
        toInformation() {
            if (this.form.fieldValue.length == "") {
                Toast("学科领域不能为空");
            } else {
                this.userInfo = JSON.parse(sessionStorage.getItem("scholarUserInfos"));
                this.userInfo.sysUserSubject[this.itemIndexs] = this.modify;
                sessionStorage.setItem("scholarUserInfos", JSON.stringify(this.userInfo));
                // console.log(this.userInfo);
                this.$router.push("information");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.deletearea {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .deletearea_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
        align-content: center;
        position: relative;

        .my {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            background: #fff;
            text-align: center;
        }

        .determine {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            position: absolute;
            right: 15px;
        }
    }

    .deletearea_bottm {
        width: 94%;
        margin: 12px auto;
        background: #fff;
        border-radius: 8px;
    }

    .prompt {
        width: 94%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin: 0 auto;
    }

    .exit {
        width: 100%;
        height: 44px;
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 22px;

        .bot {
            width: 94%;
            height: 44px;
            border-radius: 22px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff3d3d;
            background: #ffffff;
            border-radius: 22px;
        }
    }
}
</style>
